import React from 'react';

import ModalView from '../modalView';

const EditContactModal = props => (
  <ModalView
    title="Edit contact"
    titleAction="Save"
    isEdit
    {...props}
  />
);

export default EditContactModal;
